export default "__VITE_ASSET__B792__gt__"